<form novalidate #setupForm="ngForm">
  <div class="setup-container">
    <div class="section-container">
      <div class="section-label identity">Identity</div>
      <div class="section-data">
        <nrwl-test-identity
          [testName]="testName"
          [customer]="customerName"
          [technician]="technicianName"
          [contact]="contact"
          [email]="email"
          [phone]="phone"
          [technicianId]="technicianId"
          [comments]="comments"
          [editMode]="editMode || cloneMode"
          (updateTestIdentity)="updateTestIdentity($event)"
        ></nrwl-test-identity>
      </div>
    </div>
    <div class="section-container">
      <div class="section-label">Endpoints</div>
      <div class="endpoint-section">
        <nrwl-agent-picker
          [testType]="'udp'"
          [originatorDevice]="selectedOriginator"
          [destinationDevice]="selectedDestination"
          [editMode]="editMode"
          [testMode]="testMode"
          [direction]="direction"
          [showDirections]="showDirections"
          (emitAgents)="onAgentChange($event)"
        ></nrwl-agent-picker>
      </div>
    </div>
    <div class="section-container">
      <div class="section-label">Test Setup</div>
      <div class="section-data">
        <div class="group">
          <div class="label">Test duration</div>
          <mat-select
            class="option-list"
            [(ngModel)]="formField.testDuration"
            name="testDuration"
            (selectionChange)="onTestDurationChange()"
            #testDurationInput="ngModel"
          >
            <mat-option *ngFor="let opt of testDurationOptions" [value]="opt.value">{{
              opt.name
            }}</mat-option>
          </mat-select>
        </div>
        <div class="group" *ngIf="formField.testDuration === 'custom'">
          <div class="label">hour:min:sec *</div>
          <input
            matInput
            autocomplete="off"
            type="text"
            class="input-data width-75"
            name="customTestDuration"
            #customTestDurationInput="ngModel"
            [(ngModel)]="formField.customTestDuration"
            placeholder="HH:MM:SS"
            (ngModelChange)="customTestDurationChange()"
            [pattern]="validTestDurationRegex"
            (input)="reformatTestDuration($event)"
            maxlength="8"
            minlength="8"
            required
            [matTooltip]="customDurationErrorMsg"
            [ngClass]="{
              'error-msg':
                !customTestDurationInput.invalid && !isvalidCustomDuration && customDurationErrorMsg
            }"
          />
          <div
            class="error"
            *ngIf="
              customTestDurationInput.invalid &&
              (customTestDurationInput.dirty || customTestDurationInput.touched)
            "
          >
            <mat-error *ngIf="customTestDurationInput?.errors?.required"
              >Duration is required</mat-error
            >
            <mat-error
              *ngIf="
                customTestDurationInput.errors?.pattern || customTestDurationInput.errors?.minlength
              "
              >Invalid test duration</mat-error
            >
          </div>
        </div>
        <div class="group">
          <div class="label">Stream rate convention</div>
          <mat-select
            name="streamRateConvention"
            #streamRateInpute="ngModel"
            class="option-list"
            [(ngModel)]="formField.streamRateConvention"
            (selectionChange)="onStreamRateConventionChange()"
          >
            <mat-option *ngFor="let conven of streamRateTypes" [value]="conven.value">{{
              conven.name
            }}</mat-option>
          </mat-select>
        </div>
        <div class="group">
          <div class="label">VLAN Config</div>
          <mat-select
            name="vlan"
            #vlanInpute="ngModel"
            class="option-list"
            [(ngModel)]="formField.vlan"
            (selectionChange)="onVlanChange()"
          >
            <mat-option *ngFor="let type of vlanTypeSelection" [value]="type.value">{{
              type.name
            }}</mat-option>
          </mat-select>
        </div>
      </div>
    </div>
    <ng-container *ngIf="!isDisabledScheduler">
      <div class="section-container height-120" *ngIf="!showExpirationField">
        <div class="section-label"><label>Schedule</label></div>
        <div class="scheduler-section">
          <viavi-scheduler
            [scheduleValue]="scheduleInfoData"
            (schedulerDataVal)="fetchSchedulerVal($event)"
            [isDisabledScheduler]="isDisabledScheduler"
            [schedulerEnds]="schedulerEnds"
          >
          </viavi-scheduler>
        </div>
      </div>
    </ng-container>
    <div class="section-container" *ngIf="showExpirationField">
      <div class="section-label">Schedule</div>
      <div class="section-data">
        <div class="group">
          <div class="label">Expiration Time(UTC)</div>
          <mat-select
            name="expireTime"
            [disabled]="!expirationTimeOverwrite"
            #expireTimeInpute="ngModel"
            class="option-list"
            [(ngModel)]="formField.expirationTime"
            (selectionChange)="onExpireTimeChange($event)"
            required
          >
            <mat-option *ngFor="let time of expireTimeData" [value]="time.value">{{
              time.name
            }}</mat-option>
          </mat-select>
        </div>
        <div class="group">
          <div class="label">
            Max Execution Counts<i
              class="mdi mdi-help-circle-outline"
              matTooltip="{{ formTooltip.maxExecutionCounts }}"
            ></i>
          </div>
          <input
            [disabled]="!executionCountsOverwrite"
            matInput
            autocomplete="off"
            type="number"
            class="input-data width-75"
            name="executionCount"
            [(ngModel)]="formField.executionCounts"
            #executionCountInput="ngModel"
            placeholder="Unlimited"
            (ngModelChange)="onExecutionCountUpdated()"
            min="0"
            [max]="maxExecutionCountValue"
          />
          <mat-error *ngIf="executionCountInput.errors?.min || executionCountInput.errors?.max">
            value should be 0 to
            {{ maxExecutionCountValue }}</mat-error
          >
        </div>
      </div>
    </div>
    <div
      class="section-container"
      *ngIf="
        setupService.clientToAgentInfo.secondaryTestURL !== null ||
        setupService.clientToAgentInfo.dmzServerUrl !== null
      "
    >
      <div class="test_url">Test URLs</div>
      <div>
        <div class="test_url-content">
          To start the test,copy a URL and paste inside a web browser
        </div>
        <div class="url-content">
          <div class="url-container" *ngIf="setupService?.clientToAgentInfo?.secondaryTestURL">
            <div
              class="vTA_url"
              (click)="copyvTAURL()"
              [cdkCopyToClipboard]="setupService.clientToAgentInfo.secondaryTestURL"
            >
              <i class="mdi mdi-content-copy"></i>
              <span>{{ getAgentURLLabel() }}</span>
            </div>
          </div>
          <div class="url-container" *ngIf="setupService?.clientToAgentInfo?.dmzServerUrl">
            <div
              class="dmz_url"
              (click)="copyDMZURL()"
              [cdkCopyToClipboard]="setupService.clientToAgentInfo.dmzServerUrl"
            >
              <i class="mdi mdi-content-copy"></i>
              <span>DMZ Test Link</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
